import { render, staticRenderFns } from "./AutoEvaluacion.vue?vue&type=template&id=a3ca9034&scoped=true"
import script from "./AutoEvaluacion.vue?vue&type=script&lang=js"
export * from "./AutoEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./AutoEvaluacion.vue?vue&type=style&index=0&id=a3ca9034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ca9034",
  null
  
)

export default component.exports